module.exports = __webpack_public_path__ + "static/img/AIprogram2.fab234d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fourthToolList/AIprogram2.png
// module id = sK7u
// module chunks = 1